export default "__VITE_PUBLIC_ASSET__41c09947__"